import { useState } from "react";
import { useTopUpPlatformCredit } from "../../../../hooks/api/mutations/usePlatformCredit";
import { pathConstants } from "../../../../routes/pathContants";

export const usePlatformCreditTopup = () => {
  const [formData, setFormData] = useState({ amount: "" });

  const { mutate: topCredit, isLoading } = useTopUpPlatformCredit();
  const handleTopUp = () => {
    topCredit(
      {
        ...formData,
        // eslint-disable-next-line no-restricted-globals
        callback_url: `${window.location.origin}${pathConstants.SETTINGS_PLATFORM_CREDIT}`,
      },
      {
        onSuccess: (res) => {
          window.location.href = res?.data?.data?.init_data?.url;
        },
      },
    );
  };

  return { isLoading, formData, setFormData, handleTopUp };
};
